import { render } from "./header.vue?vue&type=template&id=6df82468"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
script.render = render

export default script